export enum SupportOptions {
    ReportAProblem,
    SystemDiagnostics,
    ContactUs,
    PlayerDiagnostics,
    Debug,
    BetaFeedback,
}
